import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { LozierStoreList } from "./types";
import {
  addUpdateLozierStoreFailure,
  addUpdateLozierStoreSuccess,
  fetchLozierStoreListFailure,
  fetchLozierStoreListSuccess,
} from "./actions";
import {
  ADD_UPDATE_LOZIER_STORE_REQUEST,
  FETCH_LOZIER_STORE_LIST_REQUEST,
} from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchLozierStoreListSaga(action: any) {
  try {
    const response: LozierStoreList[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = response.length > 0 ? response[0].totalCount : 0;
    yield put(fetchLozierStoreListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchLozierStoreListFailure(errorMessage));
  }
}

function* addUpdateLozierStoreSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdateLozierStoreSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateLozierStoreFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* lozierStoreSaga() {
  yield takeLatest(FETCH_LOZIER_STORE_LIST_REQUEST, fetchLozierStoreListSaga);
  yield takeLatest(ADD_UPDATE_LOZIER_STORE_REQUEST, addUpdateLozierStoreSaga);
}
